import { useTranslation } from 'react-i18next';
export function useBadgingTranslation() {
    return useTranslation('badging');
}
